/* global common */
import {
  sendGoogleEvent,
  libInit,
  parameters,
  sendRequest,
} from '@html/_common/utils';

export default function AOTourFlexibleOptionsPopup(tourId) {
  const EVENT_CATEGORY = 'Tour Detail';
  const FLEXIBLE_CARD_JS_SELECTOR = '.js-ao-tour-flexible-options-card';
  const MODAL_JS_SELECTOR = '.js-ao-common-cancellation-popup__content';
  const MODAL_HEADING_JS_SELECTOR = '.js-ao-common-cancellation-popup__heading';
  const CLOSE_POPUP_JS_SELECTOR = '.js-ao-common-cancellation-popup__close';
  const BACK_POPUP_JS_SELECTOR = '.js-ao-common-cancellation-popup__back';
  const CTA_JS_SELECTOR = '.js-ao-tour-flexible-options-card__cta';
  let popupLoaded = false;
  let htmlData = null;

  this.common = typeof sendGoogleEvent !== 'undefined' ? {
    sendGoogleEvent,
    parameters,
    sendRequest,
    lib: {
      init: libInit,
    },
  } : common;

  this.initiate = () => {
    if ($(FLEXIBLE_CARD_JS_SELECTOR).length === 0) {
      return;
    }

    $('body').on('click', CTA_JS_SELECTOR, () => {
      const url = `/api/book-now/tour_cancellations/${tourId}`;
      this.loadCancellationData(url);

      this.common.sendGoogleEvent(
        EVENT_CATEGORY,
        'Explore your options',
        'Open modal',
        {
          ampEventName: 'tdp_peace_of_mind_clicked',
          tdp_peace_of_mind_clicked_modal: 'Open',
        },
      );
    });

    this.common.sendGoogleEvent(
      EVENT_CATEGORY,
      'Loaded Explore your options',
      '',
      {
        nonInteraction: true,
      },
    );
  };

  this.openPopup = (html) => {
    this.common.lib.init('popup', () => {
      $.magnificPopup.open({
        mainClass: 'ao-common-scout-modal__container',
        items: {
          type: 'inline',
          src: html,
          closeOnBgClick: true,
          enableEscapeKey: true,
          showCloseBtn: false,
        },
      });

      if (this.common.parameters.is_mobile) {
        $('.ao-common-cancellation-popup__overlay').removeAttr('style');
        $('body').css('overflow', 'hidden');
      }

      this.closePopup();
      this.handlePolicyLinksClick();
      this.onCustomerSupportClick();
    });
  };

  this.loadCancellationData = (url) => {
    if (popupLoaded) {
      this.openPopup(htmlData);
      return;
    }

    this.common.sendRequest(url, {}, (data) => {
      if (data.success === true) {
        popupLoaded = true;
        htmlData = data.component;
        this.openPopup(htmlData);
      }
    });
  };

  this.closePopup = () => {
    $('body').on('click', CLOSE_POPUP_JS_SELECTOR, () => {
      $.magnificPopup.close();

      if (this.common.parameters.is_mobile) {
        $('body').css('overflow', 'unset');
      }
    });
  };

  this.handlePolicyLinksClick = () => {
    $('body').on('click', '.js-ao-common-cancellation-popup__item-link', (event) => {
      const policyType = $(event.currentTarget).data('type');
      const policyHeading = $(event.currentTarget).data('heading');

      const $policyContent = $(`.js-ao-common-cancellation-popup__policy--${policyType}`);
      $policyContent.removeClass('hid').siblings().addClass('hid');
      $(MODAL_HEADING_JS_SELECTOR).text(policyHeading);

      $(BACK_POPUP_JS_SELECTOR).removeClass('hid');
      this.handleBackButtonClick();

      this.common.sendGoogleEvent(
        EVENT_CATEGORY,
        `Explore your options - ${policyType}`,
        {
          ampEventName: 'tdp_peace_of_mind_clicked',
          tdp_peace_of_mind_clicked_modal_policy: 'Yes',
        },
      );
    });
  };

  this.handleBackButtonClick = () => {
    $('body').on('click', BACK_POPUP_JS_SELECTOR, (event) => {
      $(event.currentTarget).addClass('hid');
      $(MODAL_JS_SELECTOR).removeClass('hid').siblings().addClass('hid');

      const mainHeading = $(MODAL_JS_SELECTOR).data('heading');
      $(MODAL_HEADING_JS_SELECTOR).text(mainHeading);
    });
  };

  this.onCustomerSupportClick = () => {
    $('body').on('click', '.js-ao-common-cancellation-popup__bottom-link', () => {
      this.common.sendGoogleEvent(
        EVENT_CATEGORY,
        'Explore your options - Customer Support',
        {
          ampEventName: 'tdp_peace_of_mind_clicked',
          tdp_peace_of_mind_clicked_modal_contact: 'Yes',
        },
      );
    });
  };
}
